/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SignatureParticipantResponseDto } from './signatureParticipantResponseDto.model';
import { SigningMethod } from './signingMethod.model';


/**
 * Signatories of the contract and the signing methods allowed in the project, for starting e-signing.
 */
export interface ContractSignatureParticipantsDto { 
    /**
     * Signing methods the current project allows, in the order AML, BANK_ID; empty when e-signing is not allowed.
     */
    allowedSigningMethods: Array<SigningMethod>;
    /**
     * Signing method a signatory gets when none is chosen for him: AML when allowed, otherwise BANK_ID; null when the project allows no signing method.
     */
    defaultSigningMethod?: SigningMethod;
    /**
     * Signatories of the contract. Their subject ids are the subjectId values the start signing request accepts.
     */
    participants: Array<SignatureParticipantResponseDto>;
}
export namespace ContractSignatureParticipantsDto {
}


